module.exports = __webpack_public_path__ + "img/banner_2.b756a3d9.jpg";